var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"b1a2da1cced9e59ae541201ea2ff2899da5fc45f"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["beatpacks@mikhail-andreev"]={id:"b1a2da1cced9e59ae541201ea2ff2899da5fc45f"};
      